module.exports = __webpack_public_path__ + "img/BJB-min.eebc8742.png";